import React, { FC, MouseEvent, useState } from 'react'

import { Row } from '../row'

import { useStyle } from './slider.styles'
import { SliderProps } from './slider.types'

export const Slider: FC<SliderProps> = ({
  className = '',
  defaultActive,
  onChange
}) => {
  const [active, changeActive] = useState(defaultActive)
  const classes = useStyle({ active })

  const handleOnClick = (
    event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>
  ) => {
    changeActive(!active)
    if (onChange) {
      onChange(!active, event)
    }
  }
  return (
    <Row
      className={`${className} ${classes.container}`}
      onClick={handleOnClick}
    >
      <div className={classes.dot} />
    </Row>
  )
}
